<ul class="footer-list">
  @for (item of footerItems(); track item.title) {
    <li>
      <button
        (click)="onListOptionClick(item.param)"
        (keyup.enter)="onListOptionClick(item.param)"
        class="footer-btn"
      >
        {{ item.title }}
      </button>
    </li>
  }
</ul>
